<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{
        currentTabIndex === 0 ? $t("_LIST_USER.TITLE") : $t("_LIST_GROUP.TITLE")
      }}</span>
    </page-header>
    <left-menu />
    <div class="right-page-content" id="list-user">
      <v-tabs
        :value="currentTabIndex"
        @change="changeTab"
        background-color="transparent"
        class="main-tab-wrapper main-tab"
      >
        <v-tab
          v-for="tabItem in tabs"
          :key="tabItem.index"
          @click="loadRoute(tabItem.routeName)"
          >{{ tabItem.label }}</v-tab
        >
      </v-tabs>
      <router-view></router-view>
    </div>
  </v-app>
</template>

<style lang="scss" scoped>
#list-user {
  .main-tab {
    padding-left: 40px;
    background-image: linear-gradient(#efefef, #ffffff);
  }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import { Role } from "@/plugins/roles";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu
  },
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("_LIST_USER.LIST_USER"),
          routeName: "listUser",
          roles: [
							Role.USER_LIST
						]
        },
        {
          index: 1,
          label: this.$t("_LIST_GROUP.LIST_GROUP"),
          routeName: "listGroup",
          roles: [
							Role.USER_GROUP
						]
        }
      ]
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    if (this.$route.name === "listUser") {
      this.currentTabIndex = 0;
    } else if (this.$route.name === "listGroup") {
      this.currentTabIndex = 1;
    }
  },
  methods: {
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>
